module.exports = __webpack_public_path__ + "static/media/logoEmilia2026.cfba7b31.png";